
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWifistrengt1Google as ObiWifistrengt1GoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wifistrengt-1-google.js';
 
 
 

 
 export const ObiWifistrengt1Google = createComponent({
   react: React,
   tagName: 'obi-wifistrengt-1-google',
   elementClass: ObiWifistrengt1GoogleElement,
   events: {
     
   }
  });
 
 